import React, { Component } from 'react';
import './App.css';
import PSPDFKit from './containers/pspdfkit';
import 'bootstrap/dist/css/bootstrap.css';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

class App extends Component {
  render() {
    console.log('app 1 start');
    let exportPdfUrl = `https://${
      this.props.match.params.client
    }/export.pdf?superid=${this.props.match.params.superid}`;
    if (process.env.NODE_ENV === 'development') {
      console.log('In dev using local pdf.');
      exportPdfUrl = '/test/test.pdf';
    }

    return (
      <div className="App">
        <PSPDFKit
          pdfUrl={exportPdfUrl}
          licenseKey="D-ClYgy3Kh83iVc2uf_7b7isVFyJkq9AvrKmMmlo3S1tNWkJwkOlYs1uW3Az5B_qta2hL8jhjJ2WiV-wVQalHPMMbmVZPYxZePViGEP8SDEX8e_lZTPvv-H7aOqyIBYHUbUO-sCmhmsu8n0KJi8A1JChc62CNPV-VmELM26W7ZL7Vbutntdt1jBwMGJvxdGJQTrY-V4X-JE0KmxYGJGL4BwnWn5VkyCUvSCVAkAnwCtEQIRqWpiWYEzSdPU9LdslBv0VgoypdI2Ye_i8TzMcYRGPd8MD8aCkLCwO0RXNYZxrbfSgLTRRKvkaWM9qr8dYJ3_yctPjudQS9tl0iRFLrkPgbETe4IAYEIVzozBDS3bpzVMrSsOA_6iUiEYuhprcQtshzUHugHzO2I2somqwq59m4O68LqcunPDASISmxd7aIEDCZKZ4bglHFdSaxx0p"
          baseUrl={baseUrl}
        />
      </div>
    );
  }
}

export default App;
